export const FlowerClosedIcon = () => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.4337 4.94024C4.39137 4.69006 4.60446 4.47234 4.85017 4.51471L7.95922 5.05088C10.2819 5.45144 12.4783 7.38271 12.8991 9.86968L13.7357 13.4143C13.7928 13.7514 13.5225 14.0478 13.2077 13.9935L9.51755 13.1137C7.19483 12.7131 5.35986 10.4137 4.93904 7.9267L4.4337 4.94024Z'
        fill='white'
      />
      <path
        d='M9.38185 2.45565L10.9507 0.802815L8.78078 0.170491C7.24092 -0.27824 5.58364 0.174131 4.47033 1.34707L2.92438 2.97582L1.32234 4.55381C0.170936 5.68794 -0.273133 7.37621 0.167361 8.94487L0.788078 11.1553L2.41057 9.55717C3.56198 8.42304 4.00605 6.73477 3.56556 5.16612L2.96223 3.0176L5.0714 3.63223C6.61126 4.08096 8.26854 3.62859 9.38185 2.45565Z'
        fill='#838383'
      />
    </svg>
  );
};
